import { SharedBuildingPlanDetailsModule } from './../project-building-plans/shared-building-plan-details.module';
import { SharedBimBuildingPlansModule } from '../project-bim-building-plans/shared-bim-building-plans.module';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { JobSignatureComponent } from './job-details/job-signature/job-signature.component';
import { JobWeatherComponent } from './job-details/job-weather/job-weather.component';
import { JobLinkingsComponent } from './job-details/job-linkings/job-linkings.component';
import { JobPhotosComponent } from './job-details/job-photos/job-photos.component';
import { JobFormDataComponent } from './job-details/job-form-data/job-form-data.component';
import { JobDetailsComponent } from './job-details/job-details.component';
import { IonicModule } from '@ionic/angular';
import { CoreModule } from '../../../core/core.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
// import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { JobExtensionComponent } from './job-details/job-extension/job-extension.component';
import { JobArticleComponent } from './job-details/job-article/job-article.component';
import { JobArticleFieldComponent } from './job-details/job-article/job-article-field/job-article-field.component';
import { ServiceGroupsPageModule } from '../../../service-groups/service-groups.module';
import { AutosizeModule } from 'ngx-autosize';
import { JobAdditionalFieldsComponent } from './job-details/job-additional-fields/job-additional-fields.component';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { NewJobLinkingComponent } from './job-details/job-linkings/new-job-linking/new-job-linking.component';
import { ProductsModule } from '../../../products/products.module';
import { DateAdapter } from '@angular/material/core';
import { CustomMomentDateAdapter } from '../../../custom-mat-date-adapter';
import { TranslatePipe } from '@ngx-translate/core';
import { TextTemplatesPageModule } from '../../../text-templates/text-templates.module';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';

import { DragDropModule } from '@angular/cdk/drag-drop';
// import { ScrollingModule } from '@angular/cdk/scrolling';

@NgModule({
    imports: [
        CoreModule,
        CommonModule,
        RouterModule,
        IonicModule,
        FormsModule,
        ReactiveFormsModule,
        FontAwesomeModule,
        NgSelectModule,
        // ScrollingModule,
        SharedBuildingPlanDetailsModule,
        SharedBimBuildingPlansModule,
        NgxMatTimepickerModule,
        // NgxMaterialTimepickerModule,
        MatMomentDateModule,
        MatDatepickerModule,
        ServiceGroupsPageModule,
        AutosizeModule,
        EditorComponent,
        ProductsModule,
        TranslatePipe,
        TextTemplatesPageModule,
        DragDropModule,
    ],
    declarations: [
        JobDetailsComponent,
        JobFormDataComponent,
        JobArticleComponent,
        JobAdditionalFieldsComponent,
        JobArticleFieldComponent,
        JobExtensionComponent,
        JobPhotosComponent,
        JobLinkingsComponent,
        NewJobLinkingComponent,
        JobWeatherComponent,
        JobSignatureComponent,
    ],
    exports: [
        JobDetailsComponent,
        JobFormDataComponent,
        JobArticleComponent,
        JobAdditionalFieldsComponent,
        JobArticleFieldComponent,
        JobExtensionComponent,
        JobPhotosComponent,
        JobLinkingsComponent,
        NewJobLinkingComponent,
        JobWeatherComponent,
        JobSignatureComponent,
    ],
    providers: [{ provide: DateAdapter, useClass: CustomMomentDateAdapter }],
})
export class SharedJobDetailsModule {}
